export default __webpack_public_path__ + "8bdcc549efa86d971c15a16b4dc67367.png";